import '@babel/polyfill';
import Vue from 'vue';
import vuetify from '@/plugins/vuetify' // path to vuetify export
import axios from 'axios';

import App from './App.vue'
import VueHighlightJS from 'vue-highlight.js';

// Highlight.js languages (All languages)
import 'vue-highlight.js/lib/allLanguages'

/*
* Import Highlight.js theme
* Fins more: https://highlightjs.org/static/demo/
*/
import 'highlight.js/styles/default.css';
import router from './router'
import VeeValidate from 'vee-validate';
import Notifications from 'vue-notification';
import Datetime from 'vue-datetime';
import VueClipboard from 'vue-clipboard2';
import VueParticles from 'vue-particles';

// import VuetifyConfirm from 'vuetify-confirm'

import moment from 'moment';
import 'moment/locale/en-gb';

import vueMoment from 'vue-moment';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import colors from 'vuetify/lib/util/colors'

import VueApexCharts from 'vue-apexcharts'

import 'typeface-fira-sans';
import '@/styles/font.css';


import { loadConfig, getConfig } from '@/select/Config';

(async () =>
{
  await loadConfig();

  

  Vue.use(Datetime)
  Vue.use(VueApexCharts)
  Vue.use(VueHighlightJS);
  Vue.component('apexchart', VueApexCharts)

  //Import axios and set it to use credentials by default.
  axios.defaults.withCredentials = true;

  // const moment = require('moment');
  // require('moment/locale/en-gb');

  Vue.use(Notifications);
  Vue.use(VeeValidate);
  // Vue.use(VuetifyConfirm);

  Vue.use(VueClipboard);
  Vue.use(VueParticles);

  Vue.use(vueMoment,
    {
      moment
    });
  Vue.config.productionTip = false

  let env = await getConfig();

  const EnvPlugin = {
    install(Vue, options)
    {
      Vue.mixin({
        data: function ()
        {
          return {
            $env: env,
          }
        },
      });
    }
  }
  Vue.use(EnvPlugin);
  new Vue({
    vuetify, 
    router,
    render: h => h(App)
  }).$mount('#app');

}) ();